export class EntityTab {
    constructor(type: string, key: string, caption: string, config: Object) {
        this.Type = type;
        this.Key = key;
        this.Caption = caption;
        this.Config = config;
    }

    public Type: string;
    public Key: string;
    public Caption: string;
    public Config: Object;
}